var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRuStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1860_5185)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1817 40.4996C10.1363 40.4996 5.5908 40.4996 2.77262 37.6859C-0.0410156 34.8723 -0.0410156 30.3677 -0.0410156 21.2768L-0.0410156 19.6768C-0.041016 10.6314 -0.0410163 6.08592 2.77262 3.26774C5.58626 0.454102 10.0908 0.454102 19.1817 0.454102L20.7818 0.454102C29.8272 0.454101 34.3727 0.454101 37.1909 3.26774C40.0045 6.08138 40.0045 10.5859 40.0045 19.6768V21.2768C40.0045 30.3223 40.0045 34.8677 37.1909 37.6859C34.3772 40.5041 29.8727 40.4996 20.7818 40.4996H19.1817Z",
    fill: "#0077FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.272 7.81845C22.2266 7.80818 21.3175 8.65027 21.3175 9.75027V12.1003L16.4084 10.8775C16.2557 10.8395 16.1034 10.8203 15.9538 10.8189C14.9084 10.8086 13.9993 11.6507 13.9993 12.7507V15.0916L9.13565 13.878C7.91293 13.5735 6.72656 14.4962 6.72656 15.7507V28.7962C6.72656 29.9053 7.48111 30.8689 8.55838 31.1371L16.3311 33.0735C17.5538 33.378 18.7402 32.4553 18.7402 31.2007V18.1553C18.7402 17.3598 18.3507 16.6416 17.7357 16.2007C17.7258 16.1686 17.7281 16.133 17.7481 16.1039C17.7822 16.0544 17.8435 16.0307 17.9008 16.048C18.9235 16.3571 19.8962 17.4025 19.9962 18.7207L20.3335 28.6753C20.3422 29.0089 20.5649 29.2935 20.879 29.398L23.6062 30.0753C24.829 30.3798 26.0153 29.4571 26.0153 28.2025C26.0475 23.898 26.0382 19.5207 26.0393 15.2025C26.0393 14.6162 25.8412 14.1662 25.6184 13.8389C25.5823 13.7844 25.5443 13.7307 25.5039 13.6789C25.4552 13.6171 25.4021 13.5585 25.3475 13.5012C25.2662 13.4157 25.1793 13.3344 25.0857 13.2616L25.0839 13.2599C25.0454 13.2211 25.0344 13.1608 25.0662 13.1153C25.1002 13.0658 25.1616 13.0421 25.2189 13.0594C26.2416 13.3685 27.2189 14.414 27.3143 15.7321L27.6516 25.6867C27.6602 26.0176 27.8807 26.3003 28.1925 26.4003L30.9243 27.0821C32.1471 27.3867 33.3334 26.464 33.3334 25.2094V12.164C33.3334 11.0549 32.5789 10.0912 31.5016 9.82304L23.7289 7.88668C23.5762 7.84859 23.4239 7.82941 23.2743 7.82804L23.272 7.81845Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1860_5185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuStore);
export default __webpack_public_path__ + "static/media/RuStore.4ce96e92126b7ae75674d10673ed2098.svg";
export { ForwardRef as ReactComponent };